var render = function render(){var _vm=this,_c=_vm._self._c;return _c('persistence-template',{attrs:{"acne-discomfort-frequency":_vm.acneDiscomfortFrequency,"first-acne-occurrence":_vm.firstAcneOccurrence,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }